export function routes($stateProvider) {
  $stateProvider
    .state('app.network', {
      url: '/redes',
      abstract: true,
      template: '<div ui-view></div>'
    })
    .state('app.network.list', {
      url: '?{page:int}&{items:int}&{state:int}&order&sort&filter',
      title: 'Gestão de Redes',
      template: require('./directory/directory.view.html'),
      controller: 'NetworkListController',
      controllerAs: 'vm',
      role: 'redeRead',
      params: {
        state: {
          value: 1,
          dynamic: true
        },
        page: {
          value: 1,
          dynamic: true
        },
        items: {
          value: 20,
          dynamic: true
        },
        order: {
          value: "id",
          dynamic: true
        },
        sort: {
          value: "asc",
          dynamic: true
        },
        filter: {
          dynamic: true
        }
      }
    })
    .state('app.network.details', {
      url: '/{id}',
      title: 'Rede',
      controller: 'NetworkDetailsController',
      controllerAs: 'vm',
      template: require('./details/details.view.html'),
      role: 'redeRead'
    })
  ;
}

routes.$inject = ['$stateProvider'];
